import {getUrlParameter, removeParamFromUrl} from "./urlHelpers";
import {scrollTo} from "./scrollTo";

export function updateDatesLastUpdated() {
    sessionStorage.setItem("lastDatesUpdatedTimestamp", Math.round(new Date().getTime() / 1000));
}

/*
export function getDatesLastUpdated() {
    return parseInt(sessionStorage.getItem("lastDatesUpdatedTimestamp"));
}
export function initDatesAutoRefresh() {
    updateDatesLastUpdated();
    setTimeout(runDatesAutoRefresh, 6000);
}

function runDatesAutoRefresh() {
    let lastUpdated = getDatesLastUpdated();

    $.ajax({
        url: "/api/dates/latest-import",
        method: "GET",
        success: function (r) {
            if (!r.started) {
                console.error(r, lastUpdated, "Can't auto refresh dates - latest import's started time is empty");
                setTimeout(runDatesAutoRefresh, 6000);
            } else if (r.started && !r.completed) {
                //console.log(r, lastUpdated, "Dates import running, increase interval");
                setTimeout(runDatesAutoRefresh, 1000);
            } else if (r.completed && r.completed > lastUpdated) {
                //console.log(r, lastUpdated, "Refresh");
                fetchDates(true);
                setTimeout(runDatesAutoRefresh, 13000);
            } else {
                //console.log(r, lastUpdated, "Regular run")
                setTimeout(runDatesAutoRefresh, 6000);
            }
        }
    })
}*/

export function fetchDates(forceUpdate = false) {
    const datesWrap = $("#place-dates-wrap");
    const placeId = datesWrap.data("id");
    let width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    if (!placeId) {
        return;
    }

    let type = "xs";

    if (width >= 768) {
        type = "lg";
    }

    if (type === localStorage.getItem("placeDatesPreviousType") && !forceUpdate) {
        return;
    }

    localStorage.setItem("placeDatesPreviousType", type);

    $.ajax({
        url: "/place-dates/" + placeId + "/" + type,
        method: "post",
        data: {}
    }).done(function (result) {
        datesWrap.html(result);

        console.log("fetched dates");

        if ($(".table-dates .date-taken").length) {
            $(".place-dates-filter").addClass("active");
        }

        let feature = parseInt(getUrlParameter("feature"));

        if (feature) {
            let specificDates = $(".date-item.date-row-" + feature);

            if (specificDates.length > 0) {
                $(".date-item").hide();
                specificDates.show();

                let label = $("#monthsDropdownLabel");
                label.html(label.data("specific-dates"));
            }

            removeParamFromUrl("feature");
        }

        initShowMoreDates();
        updateMonths();
        updateDatesLastUpdated();
    });
}

function updateMonths() {
    var months = [];

    const dates = document.getElementsByClassName("date-item");
    for (let i = 0; i < dates.length; i++) {
        let item = dates[i];

        let classesString = item.className;
        let classes = classesString.split(" ");
        for (let c = 0; c < classes.length; c++) {
            let classItem = classes[c];

            if (classItem.indexOf("month-") !== -1) {
                let monthNumber = classItem.replace("month-", "");
                months.indexOf(monthNumber) === -1 ? months.push(monthNumber) : "";
            }
        }
    }

    let monthInputs = document.querySelectorAll(".month-dropdown-item");

    for (let i = 0; i < monthInputs.length; i++) {
        let monthInput = monthInputs[i];
        let monthInputId = monthInput.dataset.month;

        if (months.indexOf(monthInputId) === -1 && parseInt(monthInputId) !== 0) {
            monthInput.remove();
        } else {
            let dropdownItem = document.getElementById("month-dropdown-" + monthInputId);

            if (dropdownItem) {
                dropdownItem.style.display = "block";
            }
        }
    }

    /*
        //https://bitbucket.org/marketsoul/chatyachalupy/issues/219
        //show current month - simulate click on current month
        let now = new Date();
        let thisMonth = now.getUTCMonth() + 1;

        let thisMonthEl = document.getElementById("month-dropdown-" + thisMonth);

        if(thisMonthEl.style.display === "block") {
            let nextMonthNumber = thisMonthEl.nextElementSibling.dataset.month
            nextMonth.setAttribute("data-target", "" + nextMonthNumber);
            console.log("simulate click")

            thisMonthEl.click();
        } else {
            //Display all moths, hide next month button
            nextMonth.style.display = "none";
        } */

    let nextMonth = document.getElementById("next-month");
    if (nextMonth) {
        nextMonth.style.display = "none";
    }

    let bookButtons = document.getElementsByClassName("book-button");
    if (bookButtons.length) {
        let biggestWidth = 0;
        for (let i = 0; i < bookButtons.length; i++) {
            let item = bookButtons[i];

            if (item.offsetWidth > biggestWidth) {
                biggestWidth = item.offsetWidth;
            }
        }

        for (let i = 0; i < bookButtons.length; i++) {
            let item = bookButtons[i];

            let parent = item.parentElement;
            parent.style.width = biggestWidth + "px";
        }
    }
}

let maxDatesHeight = 530;

function getPlaceDatesWrap() {
    return document.getElementById("place-dates-wrap");
}

function initShowMoreDates() {
    let showMoreDates = document.getElementById("show-more-dates");

    if(showMoreDates) {
        let wrap = getPlaceDatesWrap();

        showMoreDates.addEventListener("click", function (e) {
            e.preventDefault();

            let wrap = getPlaceDatesWrap();
            let wrapHeight = wrap.offsetHeight;

            scrollTo(wrap, wrapHeight, 500);

            showMoreDates.style.display = "none";
        });

        wrap.addEventListener("scroll", function () {
            if(wrap.scrollTop < 1 && showMoreDates.classList.contains("applicable")) {
                showMoreDates.style.display="block";
                return;
            }

            if (showMoreDates.style.display !== "none") {
                showMoreDates.style.display = "none";
            }
        });

        updateShowMoreDates();
    }
}

export function updateShowMoreDates() {
    let showMoreDates = document.getElementById("show-more-dates");
    let table = document.querySelector(".table-dates");

    const tolerance = 65;
    let tableHeight = table.offsetHeight;

    let tolerableHeight = tableHeight - tolerance;

    if (tolerableHeight > maxDatesHeight) {
        showMoreDates.style.display = "block";
        showMoreDates.classList.add("applicable");
    } else {
        showMoreDates.style.display = "none";
        showMoreDates.classList.remove("applicable")
    }
}